import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgSanatvamadan = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#sanatvamadan_svg__a)'>
      <path
        fill='#A88B53'
        d='M.004.004q3.323-.006 6.647 0c.2-.02.313.166.44.285l4.914 4.915q2.537-2.55 5.086-5.089a.3.3 0 0 1 .267-.114c2.214.004 4.427-.004 6.64.004q.009 8.55 0 17.1c-.004 2.291.008 4.584-.006 6.877-1.244.031-2.49.005-3.734.014H2.742c-.912-.009-1.825.017-2.736-.016Q-.004 11.992.004.005m2.529 2.527q-.005 9.468 0 18.936h18.939q-.006-9.42 0-18.837c.025-.1-.09-.106-.155-.1q-1.48.002-2.959 0a.25.25 0 0 0-.206.093C16.7 4.08 15.242 5.53 13.791 6.988q1.27 1.266 2.537 2.535a.2.2 0 0 0 .176.067c1.572.012 3.145-.017 4.716.013-.746 1.001-1.52 1.98-2.281 2.968-1.024.01-2.049-.005-3.073.008.58.572 1.159 1.146 1.728 1.728-.12.185-.29.33-.443.486a2849 2849 0 0 1-5.037 5.039l-.11.017c-1.448-1.455-2.904-2.903-4.356-4.358-1.602-.01-3.204.009-4.81-.01.13-.266.341-.478.515-.714.535-.701 1.078-1.396 1.615-2.095.07-.083.14-.2.269-.178.986-.003 1.973 0 2.96 0-.577-.584-1.163-1.157-1.737-1.742 1.236-1.266 2.506-2.5 3.746-3.762C8.782 5.543 7.333 4.12 5.904 2.68c-.073-.068-.146-.165-.258-.151H2.531zm5.826 9.883c-.079.053-.053.156.015.204a937 937 0 0 0 3.675 3.678c1.202-1.212 2.414-2.416 3.62-3.622.044-.054.138-.128.047-.184Q13.86 10.629 12 8.774a1806 1806 0 0 1-3.642 3.64'
      />
    </g>
    <defs>
      <clipPath id='sanatvamadan_svg__a'>
        <path fill='#fff' d='M0 0h24.003v23.998H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgSanatvamadan)
export default ForwardRef
